// unreadCount.actions.ts
import { createAction } from 'typesafe-actions';

// Action to set the initial unread count
export const setInitialUnreadCount = createAction('SET_INITIAL_UNREAD_COUNT')<number>();

// Action to decrement the unread count
export const decrementUnreadCount = createAction('DECREMENT_UNREAD_COUNT')();
